/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import Skeleton from '../components/Skeleton';
import TrialEndedContent from '../components/home/TrialEnded';

export default function TrialEnded() {
  const { t } = useTranslation();

  return (
    <Skeleton title={t('Klang.ai | Trial Ended')}>
      <TrialEndedContent />
    </Skeleton>
  );
}
